import { render } from "./avatar.vue?vue&type=template&id=16ea3730&scoped=true"
import script from "./avatar.vue?vue&type=script&lang=js"
export * from "./avatar.vue?vue&type=script&lang=js"

import "./avatar.vue?vue&type=style&index=0&id=16ea3730&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ea3730"]])

export default __exports__